import * as ast from '../../generated/ast.js';
import { checkForDuplicateAndRequiredProperties } from '../../common/utilities.js';
export function validateQuickReplyJson(quickReplyJson, accept) {
    // Get the parent Node to which this belongs. The full path to that is
    // QuickReplyJson => RichAssetQuickReply => RichAsset => Node
    const parentNode = quickReplyJson?.$container?.$container
        ?.$container;
    // Check for duplicate and required properties
    checkForDuplicateAndRequiredProperties({
        node: quickReplyJson,
        allProperties: quickReplyJson.properties,
        requiredProperties: [
            ast.TypeStaticProperty,
            ast.QuickReplyOptionsArrayProperty,
        ],
        parentNode,
        accept,
    });
}
export function validateQuickReplyOption(quickReplyOption, accept) {
    // Get the parent Node to which this belongs. The full path to that is
    // QuickReplyOption => QuickReplyJson => RichAssetQuickReply => RichAsset => Node
    const parentNode = quickReplyOption?.$container?.$container?.$container
        ?.$container?.$container;
    // Check for duplicate and required properties
    checkForDuplicateAndRequiredProperties({
        node: quickReplyOption,
        allProperties: quickReplyOption.properties,
        requiredProperties: [ast.LabelProperty, ast.DestProperty],
        parentNode,
        accept,
    });
}
//# sourceMappingURL=quick-reply.js.map